module.exports = __webpack_public_path__ + "static/dedicated_customer_service_manager.b0454f98.png";